import React, { useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import axios from 'axios';
import { useSelector } from 'react-redux';
import useAxios from '../../CustomHooks/useAxios';

const { Title, Paragraph } = Typography;

export default function ForceUpdateContact() {
    const { axiosi } = useAxios();
    const [loading, setLoading] = useState(false);
    const user = useSelector((state) => state.loginReducer.user);
    const [form] = Form.useForm();

    const handleLogoutFlow = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_DOMAIN}/users/logout`,
                { user },
                { withCredentials: true }
            );
        } catch (e) {
            console.error("Logout error:", e);
        }
        localStorage.removeItem("loginStatus");
        window.location.reload();
    };

    const onFinish = async (values) => {
        const email = values.email?.trim();
        const tel = values.tel?.trim();

        if (!email && !tel) {
            return message.error("Vui lòng nhập ít nhất Số điện thoại hoặc Email!");
        }

        // Kiểm tra định dạng Email nếu có nhập
        if (email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                return message.error("Định dạng Email không hợp lệ!");
            }
        }

        // Kiểm tra định dạng Số điện thoại nếu có nhập
        if (tel) {
            const telRegex = /^[0-9+]{8,15}$/;
            if (!telRegex.test(tel)) {
                return message.error("Số điện thoại không hợp lệ! (Chỉ cho phép số, dấu +, từ 8 đến 15 ký tự)");
            }
        }

        try {
            setLoading(true);
            const agent = user?.agents?.[0] || {};
            const res = await axiosi.put(`/agents/${agent.id}/updateprofile`, {
                name: agent.name,
                username: agent.username,
                email: email || '',
                tel: tel || '',
                company_id: agent.company_id
            });

            message.success(res.data.message || "Cập nhật thông tin liên hệ thành công! Hệ thống sẽ khởi động lại.");

            setTimeout(async () => {
                await handleLogoutFlow();
            }, 2000);

        } catch (error) {
            message.error(error.response?.data?.message || "Lỗi cập nhật thông tin. Vui lòng liên hệ Admin.");
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#eef2f5' }}>
            <div style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)', width: '450px' }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <Title level={3} type="warning" style={{ margin: 0 }}>Cập Nhật Thông Tin Liên Hệ</Title>
                    <Paragraph style={{ marginTop: '10px' }}>
                        Tài khoản của bạn hiện tại đang thiếu cả <strong>Số điện thoại</strong> và <strong>Email</strong>.
                        Vui lòng bổ sung ít nhất một trong hai thông tin này để tiếp tục làm việc.
                    </Paragraph>
                </div>

                <Form
                    layout="vertical"
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item
                        label="Số điện thoại"
                        name="tel"
                        tooltip="Nhập số điện thoại để khách hàng có thể liên lạc"
                    >
                        <Input placeholder="Nhập số điện thoại (ví dụ: 0901234567)" />
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"
                        tooltip="Nhập email của bạn (ví dụ: user@nestle.com)"
                    >
                        <Input type="email" placeholder="Nhập địa chỉ Email" />
                    </Form.Item>

                    <Button 
                        type="primary" 
                        htmlType="submit" 
                        size="large" 
                        block 
                        loading={loading}
                        disabled={loading}
                    >
                        CẬP NHẬT VÀ KHỞI ĐỘNG LẠI
                    </Button>
                </Form>
            </div>
        </div>
    );
}
